import logger from 'src/utils/logger/logger';

export const setSeekInterval = function (callback, intervalTime) {
  logger.debug('Playerinterval setSeekInterval');
  const seekInterval = {
    interval: intervalTime * 1000,
    callback: callback,
    stopped: false,
    timeout: null,
    initBucle: function () {
      //Do a stopped state
      if (seekInterval.stopped) {
        logger.debug('[NPC] Playerinterval setSeekInterval initBucle en stop (ready to track next seek)');
        return;
      }
      logger.debug('[NPC] Playerinterval setSeekInterval initBucle');
      let result;
      result = seekInterval.callback.call(seekInterval);
      logger.debug('[NPC] Playerinterval setSeekInterval initBucle tiene result: ' + result);
      if (typeof result == 'number') {
        if (result === 0) {
          return;
        }
        seekInterval.interval = result;
      }
      // After do a seek, reinit loop (bucle method) to get next state: stopped state (above)
      seekInterval.bucle();
    },
    stop: function () {
      logger.debug('[NPC] Playerinterval setSeekInterval stop');
      this.stopped = true;
      clearTimeout(this.timeout);
    },
    start: function () {
      logger.debug('[NPC] Playerinterval setSeekInterval start');
      this.stopped = false;
      return this.bucle();
    },
    bucle: function () {
      logger.debug('[NPC] Playerinterval setSeekInterval bucle ' + this.interval);
      this.timeout && clearTimeout(this.timeout);
      this.timeout = setTimeout(this.initBucle, this.interval);
      return this;
    }
  };

  return seekInterval.start();
};



// WEBPACK FOOTER //
// ./src/playerDomain/components/seekIntervalUtil.js